import { faEdit } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Formik } from 'formik';
import { observer } from 'mobx-react';
import { useContext, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { storesContext } from '../../../../stores/storesContext';
import { errorToast, successToast } from '../../../helpers/toasts/ToastUtils';
import BlockForm from './BlockForm';

const UpdateBlockModal = ({ monitoringBlock }) => {
  const userStore = useContext(storesContext);
  const alcmStore = userStore.alcmStore;
  const propertiesStore = userStore.propertiesStore;

  const [open, setOpen] = useState(false);

  const show = () => setOpen(true);
  const hide = () => setOpen(false);

  return (
    <>
      <Button
        variant='link'
        size='sm'
        onClick={() => {
          show();
        }}
      >
        <FontAwesomeIcon icon={faEdit} />
      </Button>
      <Modal backdrop='static' size='lg' show={open} onHide={() => hide()}>
        <Modal.Header closeButton>
          <Modal.Title>Update Block</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={{
              block_id: monitoringBlock.block_id,
              property_id: monitoringBlock.property_id,
              station_id: monitoringBlock.station_id,
              variety: monitoringBlock.variety,
              rootstock: monitoringBlock.rootstock,
              g2_trap_catch_peak_date: monitoringBlock.g2_trap_catch_peak_date,
              g2_egg_peak_date: monitoringBlock.g2_egg_peak_date,
              geom: monitoringBlock.geom || null
            }}
            validate={(values) => {
              const errors = {};
              if (!values.block_id) errors.block_id = 'Required';
              if (!values.station_id) errors.station_id = 'Required';
              return errors;
            }}
            onSubmit={async (values, actions) => {
              try {
                await alcmStore.updateMonitoringBlock(monitoringBlock.id, {
                  block_id: values.block_id,
                  property_id: values.property_id,
                  station_id: values.station_id,
                  variety: values.variety,
                  rootstock: values.rootstock,
                  g2_trap_catch_peak_date: values.g2_trap_catch_peak_date,
                  g2_egg_peak_date: values.g2_egg_peak_date,
                  geom: values.geom
                });
                await alcmStore.fetchMonitoringBlocks(
                  propertiesStore.selectedProperty.id
                );
                successToast('Block updated successfully.');
                hide();
              } catch (err) {
                errorToast('Failed to update block.');
              } finally {
                actions.setSubmitting(false);
              }
            }}
          >
            {() => {
              return <BlockForm onCancel={hide} showPropertySelect />;
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default observer(UpdateBlockModal);

